import { OwcTypography } from '@one/react';
import { useTranslation } from 'core/i18n';
import { RefreshButton } from '../generic-buttons';
import { ContentWithFooterLayout } from '../layouts';
import { GenericErrorLayout } from './generic-error.style';

export const GenericErrorComponent: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <ContentWithFooterLayout footer={<RefreshButton />}>
      <GenericErrorLayout>
        <img src="/assets/images/generic-error.svg" alt={t('components.generic-error.alt')} />
        <OwcTypography variant="body1" mode="regular" className="text-center">
          {t('components.generic-error.message')}
        </OwcTypography>
      </GenericErrorLayout>
    </ContentWithFooterLayout>
  );
};
